<template>
    <ul>
        <li class="content-list">
            <ProviderExpand :providerwise-patient-count="providerwisePatientCount('last_seven')"
                :total-count="totalCount['last_seven']"
                toRoute="/upcoming/last_seven"
                type="upcoming"
                day="last_seven">
                    Appt - Past 7 Days
            </ProviderExpand>
        </li>
        <li class="content-list">
            <ProviderExpand :providerwise-patient-count="providerwisePatientCount('last_fourteen')"
                :total-count="totalCount['last_fourteen']"
                to-route="/upcoming/last_fourteen"
                type="upcoming"
                day="last_fourteen">
                    Appt - Past 14 Days
            </ProviderExpand>
        </li>
    </ul>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import SidebarList from '.'
import ProviderExpand from './ProviderExpand'
import isEmptyObject from '@/module/util/empty-object'

export default {
    name: 'sidebar-previous-list',
    extends: SidebarList,

    data() {
        return {
            totalCount: {
                last_seven: 0,
                last_fourteen: 0
            }
        }
    },


    methods: {
        providerwisePatientCount(day) {
            let tempObj = {}

            if(this.overview && 
                this.overview.schedule && 
                this.overview.schedule[day] && 
                Object.keys(this.overview.schedule[day]).length > 0) {
                    this.totalCount[day] = this.findPatientWiseCntForDay(this.overview.schedule[day])
                    return this.overview.schedule[day]
                    // Object.entries(this.overview.schedule[day]).forEach((provWisePat) => {
                    //     if(provWisePat[1].length > 0) tempObj[provWisePat[0]] = provWisePat[1]
                    // })
            }

            // this.totalCount[day] = this.findPatientWiseCntForDay(tempObj)
            // return tempObj
        },
        findPatientWiseCntForDay(provWisePatient) {
            let res = Object.values(provWisePatient).reduce((acc, curr) => {
                acc += curr.length
                return acc
            }, 0)
            return res
        }
    },

    computed: {
        ...mapState('provider', [
            'overview',
            'providerPatients'
        ]),
        ...mapGetters('provider', [
            'getProviderPatientList',
            'getAllProviderPatientList',
            'getProviderList'
        ]),
        ...mapGetters(['getUserType']),
    },

    components: {
        ProviderExpand
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
